// Note: This mixin is used to communicate between components
import { findAllComponentsInTitleOptions, replaceUrlParam, _throttle, _debounce } from "utils"

export default {
  watch: {
    // 监听子组件的事件
    currentPageNum(n, o) {
      if (this.options.noCacheComponent && o !== n && typeof n !== "undefined") {
        console.log("currentPageNum")
        this.timerUpdate("pagination")
      }
    },
    currentNavMenuValue(o, n) {
      if (this.options.noCacheComponent && o !== n) {
        this.isInitPaginationCurrentPageFlag = true
        console.log("navMenu")
        this.timerUpdate("navMenu")
      }
    }
  },
  computed: {
    currentPageNum() {
      for (let i = 0; i < this.options.titleOptions.length; i++) {
        if (this.options.titleOptions[i].elementOptions.length > 0) {
          const elementOptions = this.options.titleOptions[i].elementOptions
          for (let j = 0; j < elementOptions.length; j++) {
            if (elementOptions[j].type === "pagination" && elementOptions[j].isShow) {
              return elementOptions[j].options.value
            }
          }
        }
      }
    },
    currentNavMenuValue() {
      for (let i = 0; i < this.options.titleOptions.length; i++) {
        if (this.options.titleOptions[i].elementOptions.length > 0) {
          const elementOptions = this.options.titleOptions[i].elementOptions
          for (let j = 0; j < elementOptions.length; j++) {
            if (elementOptions[j].type === "navMenu" || elementOptions[j].type === "navMenuVertical") {
              return elementOptions[j].options.value
            }
          }
        }
      }
    }
  },
  methods: {
    /**
     * !!!!!初始化自由布局中的其他组件（分页、tabs分类、多级导航、垂直多级导航、标题、更多）
     * !!!!考虑到自由布局的使用场景不同，需要先判断组件是否存在，在进行对应的业务数据填充
     */
    initTitleOptionsAllComponents(rectAttr, restUrl, totalRecords, pageSize) {
      const AllOtherComponents = findAllComponentsInTitleOptions(rectAttr)
      if (AllOtherComponents.length === 0) return
      for (let i = 0; i < AllOtherComponents.length; i++) {
        switch (AllOtherComponents[i].type) {
          case "classification":
            // 初始化tabs组件
            this.initTabsData(AllOtherComponents[i].directionIndex, AllOtherComponents[i].elementInLayoutId, restUrl)
            break
          case "pagination":
            // 初始化分页组件
            this.initPaginationData(
              AllOtherComponents[i].directionIndex,
              AllOtherComponents[i].elementInLayoutId,
              totalRecords,
              pageSize
            )
            break
          case "more":
            // 初始化更多组件
            break
          case "breadCrumbs":
            // 初始化面包屑组件
            this.initBreadCrumbsData(
              AllOtherComponents[i].directionIndex,
              AllOtherComponents[i].elementInLayoutId,
              restUrl
            )
            break
          case "navMenuVertical":
            // 初始化多级导航组件
            this.initNavMenuData(AllOtherComponents[i].directionIndex, AllOtherComponents[i].elementInLayoutId, restUrl)
            break
          case "navMenuVertical":
            // 初始化垂直多级导航组件
            this.initNavMenuData(AllOtherComponents[i].directionIndex, AllOtherComponents[i].elementInLayoutId, restUrl)
            break
        }
      }
    },
    // 请求数据完成后初始化tab组件
    initTabsData(directionIndex, elementInLayoutId, restUrl) {
      const tabsData = []
      restUrl.data.data.generalDataTypes.forEach(item => tabsData.push({ id: item.publicId, name: item.name }))
      // 同步分类的时候，需要把多余的row删除，不够的补上一行一列的容器
      const tabParams = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        pageId: this.myid.pageId,
        elementInLayoutId: elementInLayoutId,
        directionIndex: directionIndex,
        maxLength: tabsData.length > 0 ? tabsData.length : 1, // tab的c长度不能为0
        isAsyncData: true
      }
      this.$store.dispatch(this.request_prefix + "/changeLayoutTabsLength", tabParams)
      let param = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        pageId: this.myid.pageId,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId,
        option_name: "tabsList",
        option_val: tabsData
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      if (this.options?.pluginName?.includes("fetch-twoTabsLayoutPlugin")) {
        this.$initPlugin(this.options?.pluginName)
      }
    },
    // 请求完数据后更新面包屑组件
    initBreadCrumbsData(directionIndex, elementInLayoutId, restUrl, breadCrumbsData) {
      let param = null
      console.log("this.subPage :>>", this.subPage)

      if (breadCrumbsData && breadCrumbsData?.data?.code === 1) {
        // 判断是初始化还是点击多级导航后的数据联动
        const sourceData = JSON.parse(
          JSON.stringify(this.options.titleOptions[directionIndex].elementOptions[elementInLayoutId].options.sourceData)
        )
        sourceData.splice(2) // 删除除前两个元素外的其他元素
        const crumbsData = breadCrumbsData.data.data.crumbs.map(item => ({
          label: item.name,
          value: item.id
        }))
        sourceData.push(...crumbsData)
        param = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          directionIndex: directionIndex,
          elementInLayoutId: elementInLayoutId,
          option_name: "sourceData",
          option_val: sourceData
        }
      } else {
        const homePageId = this.$store.state[this.request_prefix].page.homePageId
        const newUrl = replaceUrlParam(window.location.href, "p", homePageId)
        let defaultParam = restUrl.data.data.generalDataTypes[0] // 默认选中第一个分类，数据可能会没有分类
        // 现在没有地方取到应用名称，先暂时写死应用名称
        const sourceData = [
          {
            label: "首页",
            path: newUrl
          },
          {
            label: this.subPage?.listPageSetting?.name ? this.subPage.listPageSetting.name : "图文"
          },
          {
            label: defaultParam?.name,
            value: defaultParam?.publicId
          }
        ]
        param = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          pageId: this.myid.pageId,
          directionIndex: directionIndex,
          elementInLayoutId: elementInLayoutId,
          option_name: "sourceData",
          option_val: sourceData
        }
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      // const crumbs = breadCrumbsData.data.data.crumbs
    },
    // 当外部传入了typeId时，获取面包屑数据，兼容老数据处理
    async getBreadCrumbsData(typeId) {
      let engineId = this.restUrl?.data?.data?.engineInstance?.publicId
      return this.$API.queryCrumbData({
        typeId: typeId,
        e: engineId
      })
    },
    // 请求完数据后初始化分页组件
    initPaginationData(directionIndex, elementInLayoutId, totalRecords, pageSize) {
      // 每次数据重新请求后都需要初始化分页组件的数据
      if (this.isInitPaginationCurrentPageFlag) {
        let param = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          pageId: this.myid.pageId,
          directionIndex: directionIndex,
          elementInLayoutId: elementInLayoutId,
          option_name: "value",
          option_val: 1
        }
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
        this.isInitPaginationCurrentPageFlag = false
      }
      if (!!totalRecords) {
        let param = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          pageId: this.myid.pageId,
          directionIndex: directionIndex,
          elementInLayoutId: elementInLayoutId,
          option_name: "total",
          option_val: totalRecords
        }
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      }
      if (!!pageSize) {
        let param = {
          container_id: this.myid.container_id,
          rect_id: this.myid.rect_id,
          pageId: this.myid.pageId,
          directionIndex: directionIndex,
          elementInLayoutId: elementInLayoutId,
          option_name: "pageSize",
          option_val: pageSize
        }
        this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      }
    },
    // 请求数据完成后初始化多级导航
    initNavMenuData(directionIndex, elementInLayoutId, restUrl) {
      let navMenuData,
        targetData = []
      navMenuData = restUrl.data.data.generalDataTypes
      this.recursiveFindDataTypes(navMenuData, targetData)
      let param = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        pageId: this.myid.pageId,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId,
        option_name: "selectOptions",
        option_val: targetData
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", param)
      let valueParam = {
        container_id: this.myid.container_id,
        rect_id: this.myid.rect_id,
        pageId: this.myid.pageId,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId,
        option_name: "value",
        option_val: navMenuData[0]?.publicId
      }
      this.$store.dispatch(this.request_prefix + "/changeTitleOptions", valueParam)
    },
    // 递归找到数据分类层级
    recursiveFindDataTypes(navMenuData, targetData) {
      for (let key in navMenuData) {
        targetData.push({
          label: navMenuData[key].name,
          value: navMenuData[key].publicId,
          iconUrl: navMenuData[key].iconUrl,
          children: []
        })
        if (typeof navMenuData[key].subGeneralDataTypes == "object") {
          this.recursiveFindDataTypes(navMenuData[key].subGeneralDataTypes, targetData[key].children)
        }
      }
    }
  }
}
